exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".progressbar{position:fixed;height:4px;background:#3ea9f5;top:0;left:0;z-index:9999}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/progressbar/progressbar.component.css"],"names":[],"mappings":"AAAA,aACE,eAAgB,WACJ,mBACQ,MACb,OACC,YACM,CACf","file":"progressbar.component.css","sourcesContent":[".progressbar{\n  position: fixed;\n  height: 4px;\n  background: #3ea9f5;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/progressbar/progressbar.component.css
// module id = 1HJj
// module chunks = 6